import React from 'react';

import Statistics from '../components/Statistics';
//import ParticipationChart from '../components/statistics/ParticipationChart';

class StatisticsPage extends React.Component {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h2>
              Global implementation status of the Programme of Action
            </h2>
            <p className="lead">
              Data from 2024 national reports covering the 2022-2023 reporting period <br />
               <span style={{fontSize: '14px'}}><i> (Data is reflected in the statistics section below if national reports are submitted online or consistent with the latest reporting template.)</i></span>
              </p>

          </div>

          <div className="col-md-6">
            {/* Overall participation statistics at the top of the statistics page */}
            {/* <h4>Years covered by national reports</h4> */}
            {/* <ParticipationChart /> */}
          </div>
        </div>

        <div className="statistics-card-wrapper">
          <div className="row">
            <Statistics />
          </div>
        </div>
        <div className="col-md-12">
       <p> * ‘No data’ includes such cases as: submitted a report but skipped an applicable question; submitted a report but not in a consistent template (e.g. a PDF copy in a free format); or not submitted a report.</p>
      </div>
      </div>
    );
  }
}

export default StatisticsPage;



// WEBPACK FOOTER //
// ./src/pages/Statistics.js